module.exports = __webpack_public_path__ + "static/media/warning-icon.83655cc5.svg";